export default __webpack_public_path__ + "static/media/un_authorized_icon_1.3cfe9cd3.png";